import { accountProfile, closeRoleTip } from '@/services'
export default {
  namespaced: true,
  state: {
    project: {},
    isNeedCost: false // 成本维护全局弹框
  },
  mutations: {
    setProject (state, project) {
      state.project = project
    },
    setNeedCost (state, status) {
      state.isNeedCost = status
    }
  },
  actions: {
    setPid ({ commit }, pid) {
      commit('setPid', pid, { root: true })
    },
    async fetchDatas ({ commit }) {
      const chain = await accountProfile().onNetSuccess(raw => {
        const { baseinfo, payload } = raw.data
        payload && commit('setProject', payload)
        baseinfo && commit('setNeedCost', baseinfo.is_need_cost)
      })
      return chain
    },
    async closeRoleTip ({ commit }) {
      const chain = await closeRoleTip()
        .config({ tip: false })
      return chain
    }
  }
}
